'use strict';

var React = require('react');

var SvgThumbsUpMajor = function SvgThumbsUpMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.539 14.57a9.249 9.249 0 0 1-4.074-.838l-.307-.14a3.751 3.751 0 0 0-1.158-.32v-5.223a1.5 1.5 0 0 0 .15-.098 6.489 6.489 0 0 0 2.475-3.95 1.41 1.41 0 0 1 1.378 1.557l-.133 1.26a1.75 1.75 0 0 0 1.74 1.932h1.595c.758 0 1.342.67 1.239 1.421l-.338 2.448a2.25 2.25 0 0 1-2.176 1.942l-.391.01Zm-7.039-6.32h-1v5h1v-5Zm2.34 6.846a10.75 10.75 0 0 0 4.735.974l.391-.01a3.75 3.75 0 0 0 3.626-3.236l.337-2.448a2.75 2.75 0 0 0-2.724-3.126h-1.594a.25.25 0 0 1-.249-.276l.133-1.26a2.91 2.91 0 0 0-2.894-3.214h-.364c-.5 0-.928.358-1.017.85l-.055.302a4.989 4.989 0 0 1-1.915 3.098h-2c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25h2.345c.324 0 .644.07.938.205l.307.14Z"
  }));
};
SvgThumbsUpMajor.displayName = "ThumbsUpMajor";

exports.SvgThumbsUpMajor = SvgThumbsUpMajor;
